import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: 'en',
    keySeparator: false, // needed to prevent problems with punctuation in translation keys
    backend: {
      loadPath: process.env.REACT_APP_LOCALES,
    },
  });

export default i18n;
